var map = {
	"./documentoAssinatura.js": "B8ys",
	"./index.js": "wMQm",
	"./responsavel.js": "6uPe",
	"./tipoDocumentoAssinatura.js": "MNj1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eQKi";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/assinatura nonrecursive \.js$
// module id = eQKi
// module chunks = 12